const React = require("react");
const {Text} = require("@react-pdf/renderer");

const styles = require("../../styles/");

module.exports = ({text}) => (
  <Text style={styles.sectionSubtitle}>
    {text}
  </Text>
);
